import { render, staticRenderFns } from "./block-notifications-list.vue?vue&type=template&id=7644de3d&scoped=true&lang=pug&"
import script from "./block-notifications-list.vue?vue&type=script&lang=js&"
export * from "./block-notifications-list.vue?vue&type=script&lang=js&"
import style0 from "./block-notifications-list.vue?vue&type=style&index=0&id=7644de3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644de3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
